import React, { useState, useEffect } from "react";
import Select from "react-select";

const MultiselectAddNew = ({ form, field, label, options = [] }) => {
  const [tags, setTags] = useState(options); // مقدار اولیه را از `options` بگیریم
  const [selectedItems, setSelectedItems] = useState([]); // گزینه‌های انتخاب‌شده
  const [inputValue, setInputValue] = useState(""); // مقدار ورودی

  // هنگام ویرایش، مقدارهای ذخیره‌شده را از فرم دریافت کرده و نمایش می‌دهد
  useEffect(() => {
    if (field.value && Array.isArray(field.value)) {
      const selectedOptions = field.value.map((value) => {
        // بررسی اگر مقدار از قبل در `tags` باشد، آن را بگیرد
        const existingTag = tags.find((tag) => tag.value === value);
        return existingTag || { label: value, value };
      });

      setSelectedItems(selectedOptions);

      // اضافه کردن گزینه‌های فرم به لیست `tags` در صورت عدم وجود
      setTags((prevTags) => [
        ...prevTags,
        ...selectedOptions.filter(
          (item) => !prevTags.some((t) => t.value === item.value)
        ),
      ]);
    }
  }, [field.value]);

  // وقتی مقدار تغییر می‌کند، فرم را آپدیت کن
  const handleChange = (items) => {
    setSelectedItems(items || []);
    form.setFieldValue(
      field.name,
      items ? items.map((item) => item.value) : []
    );
  };

  // هنگام اضافه کردن مقدار جدید
  const handleCreateOption = () => {
    if (!inputValue.trim()) return;

    // بررسی اینکه مقدار از قبل وجود نداشته باشد
    const exists = tags.find((tag) => tag.label === inputValue);
    if (exists) {
      setSelectedItems([...selectedItems, exists]);
      form.setFieldValue(
        field.name,
        [...selectedItems, exists].map((i) => i.value)
      );
      setInputValue(""); // مقدار ورودی پاک شود
      return;
    }

    // ایجاد مقدار جدید
    const newTag = {
      label: inputValue,
      value: inputValue.replace(/\s+/g, "-"), // تبدیل مقدار به اسلاگ
    };

    setTags((prevTags) => [...prevTags, newTag]); // اضافه کردن به لیست
    const updatedSelected = [...selectedItems, newTag]; // اضافه کردن به گزینه‌های انتخاب‌شده
    setSelectedItems(updatedSelected);
    form.setFieldValue(
      field.name,
      updatedSelected.map((i) => i.value)
    );
    setInputValue(""); // مقدار ورودی پاک شود
  };

  return (
    <div className="text-xs col-span-2">
      <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
        {label}
      </label>
      <Select
        placeholder="تایپ کنید و Enter بزنید..."
        value={selectedItems}
        onChange={handleChange}
        onInputChange={(value, { action }) => {
          if (action !== "input-blur" && action !== "menu-close") {
            setInputValue(value); // مقدار تایپ‌شده را نگه‌دار
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && inputValue) {
            e.preventDefault();
            handleCreateOption();
          }
        }}
        inputValue={inputValue}
        options={tags}
        isClearable
        isMulti
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        noOptionsMessage={() => "برای اضافه کردن، تایپ کنید و Enter بزنید"}
      />
      {form.errors[field.name] && (
        <span className="text-xs text-red-400">{form.errors[field.name]}</span>
      )}
    </div>
  );
};

export default MultiselectAddNew;
